export default __webpack_public_path__ + "static/aboutIdentity-mobile-68e5ce4bc9db39bcdc04f437d657b0b3.svg";